export default function SubmitButton({ isLoading, isDisabled }) {
  return (
    <button type="submit" className="submit-button" disabled={isDisabled || isLoading}>
      {isLoading ? "Adding..." : "Add This Service"}
    </button>
  )
}
